





































import { Nullable } from "@/types";
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean as PropType<Nullable<boolean>>,
      default: () => null
    },

    required: Boolean,

    defaultValue: Boolean,

    isValid: Boolean,

    hasChanges: Boolean,

    disabled: Boolean,

    label: { type: String, default: "" }
  },

  created() {
    if (this.value === null && typeof this.defaultValue !== "undefined") {
      this.$emit("input", this.defaultValue);
    }
  },

  methods: {
    onInput(val: boolean) {
      if (val === this.value) this.$emit("input", null);
      else this.$emit("input", !!val);
    }
  }
});
